<template>
  <div class="jumbotron">
    <h2>Page not found</h2>
    <p>This page was deleted, moved or never existed.</p>
    <p><a class="btn btn-primary btn-lg" href="#" role="button">Go to main page</a></p>
  </div>
</template>

<script>
export default {
  name: "NotFoundView"
};
</script>
